import * as ramda from 'ramda';

/**
 * Truncate an array of objects to a given length and
 * append an object that summarizes the items that were truncated off the given list.
 *
 * @param  {Array}  list An array of objects to truncate.
 * @param  {Number} length The total length of the truncated result plus the
 *                  summary item.
 * @param  {Array}  keys An array of keys that are mapped with the given list
 *                  to summarize values.
 * @param  {Object} [summaryItem] Optional object to pass as the summary item
 *                  that will contain the rolled up numbers that were truncated
 *                  off of the given list.
 * @return {Array}  A truncated list that contains a summary of all the
 *                  items that were truncated off of the given list.
 */
export function truncateListWithSummary(list, length, keys, summaryItem = {}) {
    const summaryOffset = 1;

    const invalid =
        !Array.isArray(list) ||
        typeof length !== 'number' ||
        list.length <= length ||
        typeof summaryItem !== 'object' ||
        !Array.isArray(keys);

    if (invalid) return list;

    // Make room for the reduced, summary item.
    const offsetLength = length - summaryOffset;
    const result = list.slice(0, offsetLength);

    const summary = ramda.clone(summaryItem);

    list.slice(offsetLength, list.length).forEach((item) =>
        keys.forEach((key) => {
            if (typeof item[key] !== 'number') return;

            if (!summary[key]) {
                summary[key] = item[key];
            } else {
                summary[key] += item[key];
            }
        })
    );

    result.push(summary);

    return result;
}
